import { FC } from "react";
import { EditAddressFormModel } from "./editSingleShareholderDomain";
import { observer } from "mobx-react";
import { MTextInput } from "../../components-v2/TextInput";
import { MSelect } from "../../components-v2/Select";

import { useTranslation } from "../../stores/RootStoreContext";

export const EditAddressForm: FC<{
  model: EditAddressFormModel;
  showField: (field: string) => boolean;
}> = observer(({ model, showField }) => {
  const { t } = useTranslation();
  return (
    <>
      {showField("address") && (
        <MTextInput label={t("shareholders.editSingle.address")} model={model.address} />
      )}
      {showField("postalCode") && (
        <MTextInput label={t("shareholders.editSingle.postalCode")} model={model.postalCode} />
      )}
      {showField("city") && (
        <MTextInput label={t("shareholders.editSingle.city")} model={model.city} />
      )}
      {showField("country") && (
        <MSelect
          label={t("shareholders.editSingle.country")}
          model={model.country}
          fullWidth={true}
        />
      )}
    </>
  );
});
